module.exports = __webpack_public_path__ + "img/bigbank.915f304.png";